<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__content">
				<h2>Are you sure you want to delete this?</h2>
            <p>The user will be notified that their survey has been deleted</p>
			<button class="btn" @click="confirmDelete">Confirm Delete</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		props : ['quoteReference', 'quoteStatus'],
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'deleteSurveyConfirmModal' + this.quoteReference,
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		},
		methods : {
			confirmDelete(){
                this.$toasted.show("Please wait...", {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: null
                })
                this.$store.dispatch('deleteSurvey', {type : this.quoteStatus, quoteReference : this.quoteReference})
                .then((response) => {
                    this.$toasted.clear();
                    if(response.confirmation === 'success'){
    					this.$toasted.success("success", {
		                    theme: 'bubble',
		                    position: 'bottom-center',
		                    duration: 5000
                        })
                        this.$store.commit('closeModal', '');
    					return;
    				} else {
                        this.$toasted.error("error: " + response.message, {
		                    theme: 'bubble',
		                    position: 'bottom-center',
		                    duration: 5000
                        })
                        this.$store.commit('closeModal', '');
    					return;
                    }
                })
                .catch((err) => {
                    this.$toasted.clear();
                    this.$toasted.error("something went wrong. " + err.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
                    })
                    this.$store.commit('closeModal', '');
                })
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/deleteSurveyConfirmModal.vue